import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import { ActivityWorkflowState } from "PFTypes";
import { useTranslation } from "react-i18next";

import { ExceptionsPill } from "./exceptions_pill";
import { mapWorkflowStatesToUI } from "./helpers";

type AuditRoleStatusBadgeProps = {
  workflowState: ActivityWorkflowState;
  getTitle?: (stateText?: string) => string;
  className?: string;
};

export const AuditRoleStatusBadge = ({ workflowState, getTitle, className }: AuditRoleStatusBadgeProps) => {
  const { t } = useTranslation("auditPlanner", { keyPrefix: "auditRoleState.workflowState" });

  if (workflowState === "exception") {
    return <ExceptionsPill getTitle={getTitle} />;
  }

  const uiWFState = mapWorkflowStatesToUI(workflowState);
  const label = t(uiWFState);

  return (
    <RoleStatusBadge
      workflowState={mapWorkflowStatesToUI(workflowState)}
      getTitle={getTitle}
      className={className}
    >
      {label}
    </RoleStatusBadge>
  );
};
